// svg polyfill for better use element support
require('svgxuse');

// track input methods for styling
require('what-input');

// automatically require all modules
require('./modules/_building.js');require('./modules/_expand.js');require('./modules/_gallery.js');require('./modules/_header.js');require('./modules/_load.js');require('./modules/_nav.js');require('./modules/_popup.js');require('./modules/_search.js');require('./modules/_slideshow.js');
